// Copy Method
export const copy = (editor) => {
  // Create Nodes
  let nodes = [];
  let data = editor.toJSON();

  for (let node of editor.selected.list) {
    nodes.push(node);
  }

  let newNodes = {};
  let newId = 1;
  nodes.forEach((currNode) => {
    // let newId = Object.keys(data.nodes).length + Object.keys(newNodes).length + 1;
    let oldNode = currNode.toJSON();

    let newNode = {
      ...oldNode,
      clonedId: oldNode.id,
      id: newId,
      position: [
        oldNode.position[0] + 10,
        oldNode.position[1] + 10
      ]
    };

    newNodes[oldNode.id] = newNode;
    newId = 1 + newId;
  });

  return JSON.parse(JSON.stringify(newNodes));
};


// Paste method
export const paste = (editor, clonnedNodes, positionMultiplier = 1) => {
  clonnedNodes = JSON.parse(JSON.stringify(clonnedNodes));

  let data = editor.toJSON();
  let newNodes = {};
  let amountOfNodes = Object.keys(data.nodes).length;

  // Create connections
  let mappedNewNodes = Object.keys(clonnedNodes).map(nodeKey => {
    return clonnedNodes[nodeKey]
  });

  Object.keys(clonnedNodes).forEach((id) => {
    let newId = clonnedNodes[id].id + amountOfNodes;
    let newNode = JSON.parse(JSON.stringify(clonnedNodes[id]));
    
    // Clone Inputs Connections
    let inputs = {};
    Object.keys(clonnedNodes[id].inputs).forEach((inputKey) => {

      // Remove connection to nodes that were not copied
      let clonedIds = mappedNewNodes.map(n => n.clonedId);
      let connections = clonnedNodes[id].inputs[inputKey].connections.filter((con) => {
        return clonedIds.includes(con.node)
      });

      // Update connection node references
      connections = connections.map((con) => {
        let newConNodeId = amountOfNodes + mappedNewNodes.filter(n => n.clonedId === con.node)[0].id
        con.node = newConNodeId;
        return con;
      });

      inputs[inputKey] = { connections };
      newNode = { ...newNode, id: newId, inputs };
    });

    // Clone Outputs Connections
    let outputs = {};
    Object.keys(clonnedNodes[id].outputs).forEach((outputKey) => {

      // Remove connection to nodes that were not copied
      let clonedIds = mappedNewNodes.map(n => n.clonedId);
      let connections = clonnedNodes[id].outputs[outputKey].connections.filter((con) => {
        return clonedIds.includes(con.node)
      });

      // Update connection node references
      connections = connections.map((con) => {
        let newConNodeId = amountOfNodes + mappedNewNodes.filter(n => n.clonedId === con.node)[0].id
        con.node = newConNodeId;
        return con;
      });

      outputs[outputKey] = { connections };
      newNode = { ...newNode, id: newId, outputs };
    });

    newNode = {
      ...newNode,
      position: [
        newNode.position[0] + 10 * positionMultiplier,
        newNode.position[1] + 10 * positionMultiplier
      ]
    };
  
    newNodes[newId] = newNode;
  });
  
  // Update editor
  data.nodes = {...data.nodes, ...newNodes};
  editor.fromJSON(data).then(() => {
    editor.view.resize();
    // AreaPlugin.zoomAt(editor);
    editor.view.container.focus();
    // compile({ engine, editor });
  });
};


const install = (editor) => {
  editor.view.container.focus();
  let globalCopy;
  let positionMultiplier = 1;
  editor.on('keydown', e => {

    if (e.target.tagName.toUpperCase() === 'INPUT') {
      return;
    }

    // Normal keys
    switch (e.code) {
      case 'Delete': {
        if (document.activeElement == document.body)
          editor.selected.each(n => editor.removeNode(n));

        break;
      }

      case 'Space': {
        let rect = editor.view.container.getBoundingClientRect();
        let event = new MouseEvent('contextmenu', {
          clientX: rect.left + rect.width / 2,
          clientY: rect.top + rect.height / 2
        });

        editor.trigger('contextmenu', { e: event, view: editor.view }); 
        break;
      }

      default: {
        break;
      }
    }

    // Ctrl + key // Command + key
    if (!e.ctrlKey && !e.metaKey) return;

    switch (e.code) {
      case 'KeyC': {
        globalCopy = copy(editor);
        break;
      }

      case 'KeyV': {
        if (globalCopy) {
          paste(editor, globalCopy, positionMultiplier);
          positionMultiplier++;
        }
        break;
      }

      case 'KeyZ': {
        editor.trigger('undo');
        break;
      }
      case 'KeyY': {
        editor.trigger('redo');
        break;
      }

      default: {
        break;
      }
    }

  });
}

export default {
  name: 'keyboard',
  install
}
